import { render, staticRenderFns } from "./GoodsCon.vue?vue&type=template&id=27069a8a&scoped=true"
import script from "./GoodsCon.vue?vue&type=script&lang=js"
export * from "./GoodsCon.vue?vue&type=script&lang=js"
import style0 from "./GoodsCon.vue?vue&type=style&index=0&id=27069a8a&prod&lang=css"
import style1 from "./GoodsCon.vue?vue&type=style&index=1&id=27069a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27069a8a",
  null
  
)

export default component.exports